<template>
  <div class="certified-section">
    <div class="certified-section-wrap container">
      <div class="certified-section__image-wrap">
        <img
          srcset="/static/images/certified@2x.jpg"
          src="/static/images/certified.jpg"
          class="certified-section__image"
        >
      </div>
      <div class="certified-section__content">
        <h4 class="certified-section__title">A certified inspection of your product</h4>
        <div class="certified-section__description">Every factory we do business with, every order placed, we inspect their facilities and products prior and on delivery to ensure quality standards are always met.</div>

        <div class="certified-section__list">
          <ul class="certified-section__left-list">
            <li class="certified-section__list__item">Certification reports (available)</li>
            <li class="certified-section__list__item">Reliability</li>
          </ul>
          <ul class="certified-section__right-list">
            <li class="certified-section__list__item">Quality inspection</li>
            <li class="certified-section__list__item">Production time capabilities</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertifiedSection',
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.certified-section
  background-color: #f6f9fc
  padding-bottom: 50px

  @include tablet
    padding-bottom: 0

.certified-section-wrap
  margin-top: 38px
  padding-top: 53px

  @include tablet
    padding-top: 59px;
    display: flex
    flex-direction: row-reverse
    padding-left: 15px
    padding-right: 19px
    justify-content: center
    padding-bottom: 80px

  @include widescreen
    max-width: 1180px
    align-items: center

.certified-section__image-wrap
  max-width: 273px
  margin-left: auto
  margin-right: auto

  @include tablet
    max-width: 50%
    margin-top: 11px
    flex-shrink: 0

  @include widescreen
    max-width: 514px
    margin-top: 14px
    padding-right: 36px

.certified-section__image
  width: 100%
  margin: 0 auto
  display: block

.certified-section__content
  margin-top: 48px

  @include tablet
    margin-top: 23px
    padding-left: 3px

  @include widescreen
    margin-top: 44px

.certified-section__title
  font-size: 28px
  font-weight: 500
  line-height: 32px
  color: #1d3762
  letter-spacing: -.4px
  margin-bottom: 28px
  padding-left: 3px

  @include tablet
    font-size: 35px
    line-height: 40px
    letter-spacing: -.6px
    padding-bottom: 0
    padding-right: 20px
    margin-bottom: 25px
    padding-left: 0

  @include widescreen
    padding-right: 207px

.certified-section__description
  color: #525f7f
  padding-left: 3px
  letter-spacing: .1px
  margin-bottom: 18px

  @include tablet
    padding-left: 1px
    padding-right: 20px

  @include widescreen
    margin-bottom: 51px
    padding-right: 150px

.certified-section__list
  display: flex
  flex-direction: column
  max-width: 500px

  @include tablet
    flex-direction: row
    position: relative
    left: -2px

.certified-section__left-list
  margin-right: 23px

  @include tablet
    margin-right: 0
    width: 55%

  @include widescreen
    margin-right: 52px
    width: 50%

.certified-section__right-list
  @include tablet
    width: 45%

    .certified-section__list__item
      padding-right: 15px
      position: relative
      left: 25px

  @include widescreen
    width: 50%

.certified-section__list__item
  padding-left: 41px
  position: relative
  font-size: 17px
  font-weight: 500
  line-height: 25px
  margin-bottom: 24px
  letter-spacing: -.2px
  color: #525f7f

  &:before
    content: ''
    width: 26px
    height: 26px
    position: absolute
    left: 0
    background-image: url(/static/images/checkmark.png)
    background-size: 100%

</style>



// WEBPACK FOOTER //
// src/CertifiedSection.vue